/**
 * Source-of-truth implementation of the IEP rider form's booster-seat default rule.
 *
 * Default ON when:
 * - Age is 6 AND CS (Car Seat) service is unavailable for the org. The org doesn't ship
 *   a car seat, so the booster recommendation acts as the fallback.
 * - Age is 7 or 8 regardless of CS availability. Booster seat is the legally required
 *   choice at these ages.
 *
 * Default OFF otherwise. Returns `false` when `age` is undefined so create-flow forms
 * without a date of birth don't pre-check the box.
 */
export const computeBoosterDefault = (age: number | undefined, isCSServiceAvailable: boolean): boolean => {
  if (age === undefined) {
    return false;
  }

  return (!isCSServiceAvailable && age === 6) || (age > 6 && age <= 8);
};
